import React from 'react';
import { T } from '../tema';
// ── Moved from App.js: CSS injection + ambient effects (PR5) ─────────
// ─────────────────────────────────────────────────────────
// HOVED APP — DEMO
// ─────────────────────────────────────────────────────────
// ── CSS Injection
if (typeof document !== "undefined") {
 const s = document.createElement("style");
 s.textContent = `
 @keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
 @keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.5; } }
 @keyframes deadline-pulse { 0%,100% { box-shadow: 0 0 0 0 rgba(255,107,107,0); } 50% { box-shadow: 0 0 6px 1px rgba(255,107,107,0.22); } }
 @keyframes nyt-pulse { 0%,100% { box-shadow: 0 0 0 0 rgba(56,189,248,0.6); } 50% { box-shadow: 0 0 10px 3px rgba(56,189,248,0.5); } }
 @keyframes haendelse-fremhæv { 0%,100% { box-shadow: 0 0 0 0 rgba(56,189,248,0); } 25%,75% { box-shadow: 0 0 0 4px rgba(56,189,248,0.35); } }
 .sv-haendelse-fremhævet { animation: haendelse-fremhæv 2.5s ease-in-out; border-radius: 14px; }
 @media (prefers-reduced-motion: reduce) { .deadline-pulse-anim, [class*="deadline-pulse"] { animation: none !important; } }
 @keyframes recovery-blink { 0%,100% { background: rgba(255,209,102,0.08); box-shadow: inset 0 0 0 1px rgba(255,209,102,0.25); } 50% { background: rgba(255,209,102,0.22); box-shadow: inset 0 0 0 1px rgba(255,209,102,0.55), 0 0 14px rgba(255,209,102,0.25); } }
 .sv-recovery-blink { animation: recovery-blink 1s ease-in-out infinite; }
 @keyframes skeletonPulse { 0%,100% { opacity:0.4; } 50% { opacity:0.8; } }
 @media (max-width: 768px) { .sv-sidebar-desktop { transform: translateX(-72px) !important; } .sv-main { margin-left: 0 !important; } }
 @keyframes deadline-gul { 0%,100% { background:rgba(255,209,102,0.15); color:#ffd166; } 50% { background:rgba(255,209,102,0.35); color:#fff; } }
 @keyframes deadline-roed { 0%,100% { background:rgba(255,107,107,0.2); color:#ff6b6b; } 50% { background:rgba(255,107,107,0.45); color:#fff; } }
 @keyframes shake { 10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-3px,0,0)}40%,60%{transform:translate3d(3px,0,0)} }
 @keyframes slideIn { from{opacity:0;transform:translateX(40px)}to{opacity:1;transform:translateX(0)} }
 .deadline-snart { animation: deadline-gul 1.8s ease-in-out infinite; border-radius:6px; padding:2px 8px; font-weight:600; }
 .deadline-overskredet { animation: deadline-roed 1.0s ease-in-out infinite; border-radius:6px; padding:2px 8px; font-weight:600; }
 @keyframes toastIn { from { opacity:0; transform:translate(-50%,-50%) scale(0.9); } to { opacity:1; transform:translate(-50%,-50%) scale(1); } }
 * { box-sizing: border-box; }
 input[type=number]::-webkit-inner-spin-button { -webkit-appearance:none; }
 ::-webkit-scrollbar { width:4px; }
 ::-webkit-scrollbar-track { background:transparent; }
 ::-webkit-scrollbar-thumb { background:rgba(255,255,255,0.08); border-radius:2px; }
 select option { background:#0d1535 !important; color:#e6dddc !important; }
 @keyframes spin { to { transform: rotate(360deg); } }
 @keyframes float { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-4px); } }
 @keyframes glow-in { from { opacity:0; transform:scale(0.92); } to { opacity:1; transform:scale(1); } }
 @keyframes shimmer { 0% { background-position:-400px 0; } 100% { background-position:400px 0; } }
 .sv-shimmer {
 background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.09) 50%, rgba(255,255,255,0.04) 75%);
 background-size: 800px 100%;
 animation: shimmer 1.6s infinite;
 }
 .sv-sag-kort { will-change: transform; }
 .sv-sag-kort:hover { transform: translateY(-4px) scale(1.01) !important; background: rgba(255,255,255,0.07) !important; }
 .sv-kpi-kort { transition: transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s ease; will-change: transform; }
 .sv-kpi-kort:hover { transform: translateY(-3px) !important; }
 @keyframes number-count { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }
 @keyframes sv-panel-enter { from { opacity:0; transform:translateY(14px) scale(0.98); } to { opacity:1; transform:translateY(0) scale(1); } }
 @keyframes sv-glow-pulse { 0%,100% { box-shadow:0 0 20px rgba(63,212,199,0.1),inset 0 1px 0 rgba(255,255,255,0.06); } 50% { box-shadow:0 0 40px rgba(63,212,199,0.2),inset 0 1px 0 rgba(255,255,255,0.10); } }
 @keyframes sv-accent-drift { 0%,100% { background-position:0% 50%; } 50% { background-position:100% 50%; } }
 @keyframes sv-status-ping { 0% { transform:scale(1); opacity:1; } 100% { transform:scale(2); opacity:0; } }
 @keyframes sv-border-glow { 0%,100% { border-color:rgba(63,212,199,0.2); } 50% { border-color:rgba(63,212,199,0.5); } }
 .sv-panel-animated { animation: sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both; }
 .sv-panel-glow-hover { transition: box-shadow 0.3s ease, border-color 0.3s ease; }
 .sv-panel-glow-hover:hover { box-shadow: 0 8px 48px rgba(63,212,199,0.08), 0 2px 12px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.08) !important; border-color: rgba(63,212,199,0.2) !important; }
 .sv-status-dot-live { position:relative; }
 .sv-status-dot-live::after { content:''; position:absolute; inset:0; border-radius:50%; background:rgba(63,212,199,0.6); animation:sv-status-ping 1.5s ease-out infinite; }
 ::-webkit-scrollbar { width:5px; height:5px; }
 ::-webkit-scrollbar-track { background:rgba(255,255,255,0.02); }
 ::-webkit-scrollbar-thumb { background:linear-gradient(180deg,rgba(63,212,199,0.3),rgba(79,70,229,0.3)); border-radius:3px; }
 ::-webkit-scrollbar-thumb:hover { background:linear-gradient(180deg,rgba(63,212,199,0.5),rgba(79,70,229,0.5)); }
 @keyframes sv-orb-drift-1 { 0%{transform:translate(0,0) scale(1)} 25%{transform:translate(12vw,-6vh) scale(1.08)} 50%{transform:translate(6vw,10vh) scale(0.94)} 75%{transform:translate(-8vw,4vh) scale(1.06)} 100%{transform:translate(0,0) scale(1)} }
 @keyframes sv-orb-drift-2 { 0%{transform:translate(0,0) scale(1)} 33%{transform:translate(-10vw,12vh) scale(1.12)} 66%{transform:translate(8vw,-8vh) scale(0.88)} 100%{transform:translate(0,0) scale(1)} }
 @keyframes sv-orb-drift-3 { 0%{transform:translate(0,0) scale(1)} 50%{transform:translate(6vw,6vh) scale(1.18)} 100%{transform:translate(0,0) scale(1)} }
 @keyframes sv-holo-shift { 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }
 /* will-change:transform → browser oppretter dedikeret compositor-layer per orb,
    så filter:blur() ikke invalider hele viewport-rasterlag ved hvert animation-frame. */
 .sv-orb { position:absolute; border-radius:50%; pointer-events:none; will-change:transform; z-index:0; }
 .sv-orb-1 { width:65vw; height:65vw; background:radial-gradient(circle, rgba(35,34,190,0.22) 0%, transparent 70%); top:-22%; left:-18%; filter:blur(60px); animation:sv-orb-drift-1 32s ease-in-out infinite; }
 .sv-orb-2 { width:55vw; height:55vw; background:radial-gradient(circle, rgba(63,212,199,0.18) 0%, transparent 70%); bottom:-18%; right:-12%; filter:blur(70px); animation:sv-orb-drift-2 40s ease-in-out infinite; }
 .sv-orb-3 { width:44vw; height:44vw; background:radial-gradient(circle, rgba(124,58,237,0.16) 0%, transparent 70%); top:38%; left:38%; filter:blur(80px); animation:sv-orb-drift-3 27s ease-in-out infinite; }
 .sv-orb-4 { width:38vw; height:38vw; background:radial-gradient(circle, rgba(201,168,76,0.11) 0%, transparent 70%); top:-8%; right:18%; filter:blur(90px); animation:sv-orb-drift-1 46s ease-in-out infinite reverse; }
 @media (max-width: 480px) { .sv-orb-1, .sv-orb-2, .sv-orb-3, .sv-orb-4 { display:none !important; } }
 /* Mobil (≤768px): stop orb-animation og holo-shift for at eliminere
    GPU-repaint af hele viewport på Android — den visuelle kilde til
    "konstant refresh"-oplevelsen. Statiske orbs bevarer udseendet. */
 @media (max-width: 768px) {
   .sv-orb { animation-play-state:paused; }
   .sv-holo-mesh { animation:none; background-position:50% 50%; }
 }
 @media (prefers-reduced-motion: reduce) {
   .sv-orb, .sv-orb-1, .sv-orb-2, .sv-orb-3, .sv-orb-4 { animation: none !important; }
   .sv-holo-mesh { animation: none !important; }
   .sv-3d-tilt, .sv-holo-card::before, .sv-status-dot-live::after { animation: none !important; }
   .sv-kpi-kort, .sv-kpi-kort:hover { animation: none !important; transform: none !important; }
   .sv-panel-animated { animation: none !important; opacity: 1 !important; }
   * { animation-duration: 0.001ms !important; transition-duration: 0.001ms !important; }
 }
 .sv-holo-mesh { background:linear-gradient(120deg,rgba(35,34,190,0.05) 0%,rgba(63,212,199,0.03) 25%,rgba(124,58,237,0.04) 50%,rgba(201,168,76,0.03) 75%,rgba(35,34,190,0.05) 100%); background-size:400% 400%; animation:sv-holo-shift 20s ease-in-out infinite; }
 .sv-3d-tilt { transform-style:preserve-3d; transition:transform 0.15s ease-out; will-change:transform; position:relative; }
 .sv-3d-tilt::after { content:''; position:absolute; top:0; left:-120%; width:60%; height:100%; background:linear-gradient(90deg,transparent,rgba(255,255,255,0.05),transparent); transform:skewX(-15deg); transition:left 0.7s ease; pointer-events:none; z-index:1; }
 .sv-3d-tilt:hover::after { left:160%; }
 .sv-scanlines { position:fixed; inset:0; pointer-events:none; z-index:1; background:repeating-linear-gradient(0deg,transparent,transparent 2px,rgba(0,0,0,0.03) 2px,rgba(0,0,0,0.03) 4px); }
 .sv-depth-fog { position:fixed; bottom:0; left:0; right:0; height:180px; pointer-events:none; z-index:1; background:linear-gradient(to top,rgba(5,8,24,0.4),transparent); }
 .sv-sidebar-glow { position:absolute; right:0; top:0; bottom:0; width:1px; background:linear-gradient(180deg,transparent 10%,rgba(63,212,199,0.3) 50%,transparent 90%); }
 .sv-dot-grid { position:fixed; inset:0; pointer-events:none; z-index:1; background-image:radial-gradient(circle, rgba(255,255,255,0.025) 1px, transparent 1px); background-size:28px 28px; }
 .sv-gradient-text { background:linear-gradient(90deg, #3fd4c7, #a78bfa, #60a5fa); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
 .sv-gradient-text-gold { background:linear-gradient(90deg, #c9a84c, #fbbf24, #f59e0b); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
 @keyframes sv-spin-border { 0%{--sv-border-angle:0deg} 100%{--sv-border-angle:360deg} }
 @keyframes sv-pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.6;transform:scale(0.85)} }
 @keyframes sv-float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }
 @keyframes sv-num-glow { 0%,100%{text-shadow:0 0 12px rgba(63,212,199,0.4)} 50%{text-shadow:0 0 28px rgba(63,212,199,0.85),0 0 60px rgba(63,212,199,0.3)} }
 @keyframes sv-border-flow { 0%{background-position:0% 50%} 100%{background-position:300% 50%} }
 @keyframes sv-fadeup { from{opacity:0;transform:translateY(18px)} to{opacity:1;transform:translateY(0)} }
 @keyframes sv-slide-right { from{opacity:0;transform:translateX(-12px)} to{opacity:1;transform:translateX(0)} }
 .sv-pulse-dot { animation:sv-pulse 2s ease-in-out infinite; display:inline-block; }
 .sv-float { animation:sv-float 4s ease-in-out infinite; }
 .sv-num-glow { animation:sv-num-glow 3s ease-in-out infinite; }
 .sv-animated-border { position:relative; isolation:isolate; }
 .sv-animated-border::before { content:''; position:absolute; inset:-1px; border-radius:inherit; background:linear-gradient(90deg,#3fd4c7,#2322be,#a78bfa,#c9a84c,#3fd4c7); background-size:300% 100%; animation:sv-border-flow 5s linear infinite; z-index:-1; padding:1px; -webkit-mask:linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0); -webkit-mask-composite:xor; mask-composite:exclude; }
 .sv-fadeup { animation:sv-fadeup 0.4s ease; }
 .sv-slide-right { animation:sv-slide-right 0.35s ease; }
 /* ── Mobil: deaktivér GPU-tunge effekter for at undgå flimren på Android/iOS (max 768px) */
 @media (max-width: 768px) {
   .sv-3d-tilt { will-change:auto; transform:none !important; transform-style:flat; }
   .sv-3d-tilt::after { display:none; }
   .sv-animated-border::before { animation:none; }
   .sv-mail-tlf-popup { backdrop-filter:blur(8px) !important; -webkit-backdrop-filter:blur(8px) !important; }
 }
 /* ── prefers-reduced-motion: stop alle dekorative animationer */
 @media (prefers-reduced-motion: reduce) {
   .sv-3d-tilt { will-change:auto; transform:none !important; transition:none !important; }
   .sv-animated-border::before { animation:none; }
   .sv-fadeup { animation:none; }
   .sv-float, .sv-pulse-dot, .sv-num-glow { animation:none; }
 }
 .sv-glass { background:rgba(255,255,255,0.04); backdrop-filter:blur(24px); -webkit-backdrop-filter:blur(24px); border:1px solid rgba(255,255,255,0.07); }
 .sv-btn-primary { background:linear-gradient(135deg, #3fd4c7, #2dc4b7); border:none; border-radius:9px; color:#0a1a1a; font-weight:700; cursor:pointer; font-family:'Inter',system-ui,sans-serif; transition:all 0.25s cubic-bezier(0.34,1.56,0.64,1); position:relative; overflow:hidden; }
 .sv-btn-primary:hover { transform:translateY(-2px) scale(1.02); box-shadow:0 8px 28px rgba(63,212,199,0.4),0 0 0 1px rgba(63,212,199,0.3); }
 .sv-btn-primary:active { transform:translateY(0) scale(0.98); }
 .sv-btn-primary::after { content:''; position:absolute; inset:0; background:linear-gradient(90deg,transparent,rgba(255,255,255,0.18),transparent); transform:translateX(-100%); transition:transform 0.5s ease; }
 .sv-btn-primary:hover::after { transform:translateX(100%); }
 .sv-btn-danger { background:linear-gradient(135deg, #ef4444, #dc2626); border:none; border-radius:9px; color:#fff; font-weight:700; cursor:pointer; font-family:'Inter',system-ui,sans-serif; transition:all 0.25s cubic-bezier(0.34,1.56,0.64,1); }
 .sv-btn-danger:hover { transform:translateY(-2px); box-shadow:0 8px 28px rgba(239,68,68,0.4); }
 .sv-btn-ghost { background:rgba(255,255,255,0.05); border:1px solid rgba(255,255,255,0.1); border-radius:9px; color:#94a3b8; font-weight:500; cursor:pointer; font-family:'Inter',system-ui,sans-serif; transition:all 0.2s ease; }
 .sv-btn-ghost:hover { background:rgba(255,255,255,0.09); border-color:rgba(255,255,255,0.18); color:#e2e8f0; transform:translateY(-1px); }
 @keyframes sv-btn-ripple { from{opacity:0.4;transform:scale(0)} to{opacity:0;transform:scale(2.5)} }
 @keyframes sv-holo-shimmer { 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }
 @keyframes sv-card-pop { 0%{opacity:0;transform:translateY(12px) scale(0.96)} 100%{opacity:1;transform:translateY(0) scale(1)} }
 @keyframes sv-ring-out { 0%{opacity:0.7;transform:scale(1)} 100%{opacity:0;transform:scale(1.5)} }
 @keyframes sv-check-pop { 0%{opacity:0;transform:scale(0.4) rotate(-20deg)} 70%{transform:scale(1.12) rotate(4deg)} 100%{opacity:1;transform:scale(1) rotate(0deg)} }
 @keyframes sv-blink { 0%,100%{opacity:1} 50%{opacity:0} }
 @keyframes sv-shimmer-text { 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }
 .sv-holo-card { position:relative; overflow:hidden; }
 .sv-holo-card::before { content:''; position:absolute; inset:0; background:linear-gradient(105deg,transparent 35%,rgba(63,212,199,0.07) 45%,rgba(167,139,250,0.07) 52%,rgba(96,165,250,0.05) 58%,transparent 65%); background-size:200% 200%; opacity:0; transition:opacity 0.4s ease; pointer-events:none; z-index:1; }
 .sv-holo-card:hover::before { opacity:1; animation:sv-holo-shimmer 2.5s ease infinite; }
 .sv-card-pop { animation:sv-card-pop 0.38s cubic-bezier(0.34,1.56,0.64,1) both; }
 .sv-typing-cursor { display:inline-block; width:2px; height:1em; background:#3fd4c7; animation:sv-blink 1s step-end infinite; vertical-align:text-bottom; margin-left:2px; }
 .sv-shimmer-text { background:linear-gradient(90deg,#3fd4c7,#a78bfa,#60a5fa,#3fd4c7); background-size:200% auto; -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; animation:sv-shimmer-text 4s linear infinite; }
 .sv-input { transition:all 0.25s cubic-bezier(0.4,0,0.2,1); }
 .sv-input:focus { outline:none; border-color:rgba(63,212,199,0.5) !important; box-shadow:0 0 0 3px rgba(63,212,199,0.08), inset 0 2px 4px rgba(0,0,0,0.1) !important; }
 .sv-glas-accent::before { content:''; position:absolute; top:0; left:0; right:0; height:1px; background:linear-gradient(90deg,transparent,rgba(63,212,199,0.3),rgba(167,139,250,0.2),transparent); border-radius:inherit; pointer-events:none; }
 `;
 document.head.appendChild(s);
}
// ── Ambient orbs — dybde-lag bag alt indhold ──
function AmbientOrbs() {
 return (
 <> <div style={{ position:"fixed", inset:0, pointerEvents:"none", zIndex:0, overflow:"hidden", clipPath:"inset(0)" }}> <div className="sv-holo-mesh" style={{ position:"absolute", inset:0 }} /> <div className="sv-orb sv-orb-1" /> <div className="sv-orb sv-orb-2" /> <div className="sv-orb sv-orb-3" /> <div className="sv-orb sv-orb-4" /> </div> <div className="sv-dot-grid" /> <div className="sv-scanlines" /> <div className="sv-depth-fog" /> </>
 );
}
// ── 3D mouse-tilt tracker + cursor glow ──
function MouseTilt3D() {
 const glowRef = React.useRef(null);
 React.useEffect(() => {
 // Cursor glow orb
 const glow = document.createElement('div');
 glow.id = 'sv-cursor-glow';
 Object.assign(glow.style, {
 position: 'fixed',
 width: '320px',
 height: '320px',
 borderRadius: '50%',
 background: 'radial-gradient(circle, rgba(63,212,199,0.06) 0%, rgba(63,212,199,0.02) 40%, transparent 70%)',
 pointerEvents: 'none',
 zIndex: '2',
 transform: 'translate(-50%, -50%)',
 transition: 'opacity 0.3s ease',
 opacity: '0',
 filter: 'blur(2px)',
 });
 document.body.appendChild(glow);
 glowRef.current = glow;
 let raf = null;
 let gx = 0, gy = 0;
 const handler = (e) => {
 gx = e.clientX; gy = e.clientY;
 if (!raf) raf = requestAnimationFrame(() => {
 raf = null;
 if (glowRef.current) {
 glowRef.current.style.left = gx + 'px';
 glowRef.current.style.top = gy + 'px';
 glowRef.current.style.opacity = '1';
 }
 });
 };
 const reset = () => {
 if (glowRef.current) glowRef.current.style.opacity = '0';
 };
 // Particle burst on click
 const BURST_COLORS = ['#3fd4c7', '#4f46e5', '#7c3aed', '#c9a84c', '#60a5fa'];
 const handleClick = (e) => {
 const N = 10;
 for (let i = 0; i < N; i++) {
 const p = document.createElement('div');
 const color = BURST_COLORS[Math.floor(Math.random() * BURST_COLORS.length)];
 const angle = (Math.PI * 2 * i) / N + (Math.random() - 0.5) * 0.4;
 const speed = 45 + Math.random() * 65;
 const sz = 3 + Math.random() * 5;
 Object.assign(p.style, {
 position: 'fixed',
 left: e.clientX + 'px',
 top: e.clientY + 'px',
 width: sz + 'px',
 height: sz + 'px',
 borderRadius: '50%',
 background: color,
 pointerEvents: 'none',
 zIndex: '9998',
 transform: 'translate(-50%,-50%)',
 boxShadow: `0 0 ${sz * 2.5}px ${color}`,
 opacity: '1',
 });
 document.body.appendChild(p);
 const tx = Math.cos(angle) * speed;
 const ty = Math.sin(angle) * speed;
 requestAnimationFrame(() => {
 p.style.transition = 'all 0.55s cubic-bezier(0.1,0.9,0.2,1)';
 p.style.transform = `translate(calc(-50% + ${tx}px), calc(-50% + ${ty}px))`;
 p.style.opacity = '0';
 p.style.width = '1px';
 p.style.height = '1px';
 });
 setTimeout(() => { if (document.body.contains(p)) document.body.removeChild(p); }, 620);
 }
 };
 document.addEventListener('mousemove', handler, { passive: true });
 document.addEventListener('mouseleave', reset);
 document.addEventListener('click', handleClick);
 return () => {
 document.removeEventListener('mousemove', handler);
 document.removeEventListener('mouseleave', reset);
 document.removeEventListener('click', handleClick);
 if (glowRef.current && document.body.contains(glowRef.current)) {
 document.body.removeChild(glowRef.current);
 }
 };
 }, []);
 return null;
}
// Deadline hjælpefunktion
// ── Global gem-bekræftelse overlay ──
function GemOverlay({ besked }) {
 if (!besked) return null;
 return (
 <div style={{ position:"fixed", top:0, left:0, right:0, bottom:0, display:"flex", alignItems:"center", justifyContent:"center", zIndex:9999, pointerEvents:"none" }}> <div style={{ background:"rgba(8,12,30,0.95)", border:`1px solid ${T.turkis}55`, borderRadius:18, padding:"20px 36px", display:"flex", alignItems:"center", gap:14, backdropFilter:"blur(20px)", boxShadow:"0 8px 40px rgba(0,0,0,0.6)", animation:"fadeUp 0.25s ease" }}> <div style={{ width:32, height:32, borderRadius:"50%", background:`${T.turkis}20`, border:`1px solid ${T.turkis}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, color:T.turkis }}></div> <div style={{ fontSize:15, fontWeight:500, color:T.creme, fontFamily:"'Inter',system-ui,sans-serif" }}>{besked}</div> </div> </div>
 );
}
// eslint-disable-next-line no-unused-vars
function deadline_klasse(deadline_str) {
 if (!deadline_str || deadline_str === "—") return "";
 const d = new Date(deadline_str);
 if (isNaN(d)) return "";
 // Sammenlign dato-for-dato (ikke klokkeslæt)
 const i_dag = new Date(); i_dag.setHours(0,0,0,0);
 const dl = new Date(d); dl.setHours(0,0,0,0);
 const diff = Math.floor((dl - i_dag) / 86400000);
 if (diff < 0) return "deadline-overskredet"; // Først rød DAGEN EFTER
 if (diff === 0) return "deadline-snart"; // I dag = gul/blink
 if (diff <= 2) return "deadline-snart";
 return "";
}
// ═════════════════════════════════════════════════════════════════════
export { AmbientOrbs, MouseTilt3D, GemOverlay };